// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"827164d2","513":"1a7e8332","787":"89589840"}[chunkId] + ".chunk.js";
};